/* globals google */
import $ from 'jquery';
import { breakpoints } from './_site';
require('jqueryUI');

let timeout = {};

export const resize = (event) => {
    var $window = $(window);

    if ($window.width() < breakpoints.md) {
        // datepicker
        changeDateInputs(false);
    } else {
        // datepicker
        changeDateInputs(true);
    }
};
export const changeDateInputs = (flag) => {
    if (flag) {
        $('[data-plugin=datepicker]')
            .attr('type', 'text')
            .datepicker({
                changeMonth: true,
                changeYear: true,
                dateFormat: 'dd-mm-yy',
            })
            .on('focus.fieldDatePicker', function() {
                initDatePicker($(this));
            });
    } else {
        $('[data-plugin=datepicker]')
            .attr('type', 'date')
            .datepicker('destroy')
            .off('focus.fieldDatePicker', function() {
                initDatePicker($(this));
            });
    }
};
export const initDatePicker = ($el) => {
    var date = new Date(),
        currentDate = $el.datepicker('getDate');

    if (!currentDate) {
        $el.datepicker('setDate', date);
        $el.trigger('checkEmpty');
        $('.ui-datepicker-prev, .ui-datepicker-next').remove();
    }
};
export const binds = ($el) => {
    /// ---------------- window events
    $(window).on('resize.fieldDatepicker', function() {
        clearTimeout(timeout.fieldDatepicker);
        timeout.fieldDatepicker = setTimeout(function() {
            resize();
        }, 100);
    });
    $(window).triggerHandler('resize.fieldDatepicker');
};
